export class ProductDetailModel {
    standardSellPrice?: number | undefined;
    productGroupName?: string | undefined;
    averageCostWithAdd?: number | undefined;
    averageCostPer?: string | undefined;
    lastCost?: number | undefined;
    lastCostPer?: string | undefined;
    standardBuyPrice?: number | undefined;
    sellPerCode?: string | undefined;
    buyPer?: string | undefined;
}
